import axios from 'axios'
import {formatTimestamp} from '@/utils/date'

var parseLinkHeader = require('parse-link-header')

const getDeviceStates = (context, payload = {page: 1}) => {
  axios
    .get(`end_device_states?page=${payload.page}`, {
      data: {},
      params: payload.params
    })
    .then(response => {
      context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'End-Device States',
        collectionId: 0,
      })
      context.commit('END_DEVICE_STATES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}


const getPromiseDeviceStates = (context, payload = {page: 1}) => {
  return new Promise ((resolve, reject) => {
    axios.get(`end_device_states?page=${payload.page}`, {
      data: {},
      params: payload.params
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const patchDeviceStateReset = (context, id = {page: 1}) => {
  return new Promise ((resolve, reject) => {
    axios.patch(`end_device_states/${id}/reset_state`, {
      data: {},
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const patchDeviceWatchlistReset = (context, id = {page: 1}) => {
  return new Promise ((resolve, reject) => {
    axios.patch(`end_device_states/${id}/reset_watchlist`, {
      data: {},
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const getDeviceRevisions = (context, payload = {page: 1}) => {
  axios
    .get(`end_devices/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('END_DEVICE_REVISIONS_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'End Device Revisions',
        collectionId: payload.id
      })
      context.commit('END_DEVICE_REVISIONS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const getDeviceProfileRevisions = (context, payload = {page: 1}) => {
  axios
    .get(`device_profiles/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('DEVICE_PROFILE_REVISIONS_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Device Profile Revisions',
        collectionId: payload.id
      })
      context.commit('DEVICE_PROFILE_REVISIONS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const getAppNetDeviceStates = (context, payload) => {
  axios
    .get(
      `application_network_states/${payload.id}/end_device_states?page=${payload.page}`,
      {
        data: {},
      }
    )
    .then(response => {
      context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Joined Devices on this Application Network',
        collectionId: payload.id,
      })
      context.commit('END_DEVICE_STATES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const getGatewayDeviceStates = (context, payload) => {
  axios
    .get(`gateway_states/${payload.id}/end_device_states?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Joined Devices for this Gateway',
        collectionId: payload.id,
      })
      context.commit('END_DEVICE_STATES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const getDeviceState = (context, payload) => {
  axios
    .get(`end_device_states/${payload.id}`, {
      data: {},
    })
    .then(response => {
      context.commit('END_DEVICE_STATE_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const updateDeviceState = (context, payload) => {
  axios
    .put(`end_device_states/${payload.data.id}`, {
      data: payload.data,
    })
    .then(response => {
      context.commit('END_DEVICE_STATE_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const getOperations = (context, payload) => {
  axios
  .get('/operations', {
    params: {
      skip: 0,
      limit: 100,
      sort: payload.sort
    }
  })
  .then(response => {
    context.commit('OPERATIONS_VIEW_UPDATED', {
      headerLinks: null,
      total: response.data.meta.pagination.count,
      perPage: response.data.meta.pagination.limit,
      context: 'Operation List',
      collectionId: payload.orgId,
      sort: payload.sort
    })
    context.commit('OPERATIONS_UPDATED', response.data.data)
  })
  .catch(error => {
    // eslint-disable-next-line
    console.error(error)
  })
}

const removeOperation = (context, payload) => {
  context.commit('OPERATIONS_REMOVE_ITEM', payload)
}

const deleteOperation = (context, payload) => {
  axios
    .delete(`operations/${payload.id}`)
    .then(response => {
      console.log(response)
      context.commit('OPERATIONS_REMOVE_ITEM', payload.id)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const addOperation = (context, payload) => {
  context.commit('OPERATIONS_ADD_ITEM', payload)
}

const getOperationDevices = (context, payload) => {
  const op = context.state.operations.find(item => item.id === payload.id)
  context.commit('OPERATION_DEVICES_UPDATED', op.attributes.eui_results)
  context.commit('OPERATION_DEVICES_STATUS_UPDATED', {
    type: op.attributes.operation_type,
    status: op.attributes.status_message,
    port: op.attributes.port,
    firmware: op.attributes.filename,
    description: op.attributes.description,
    last_updated: formatTimestamp(op.attributes.updated_at),
    scheduled_to_run_at: formatTimestamp(op.attributes.scheduled_to_run_at),
    started_at: formatTimestamp(op.attributes.started_at),
    completed: op.attributes.percent_complete
  })
  context.commit('OPERATION_DEVICES_VIEW_UPDATED', {
    headerLinks: null,
    total: op.attributes.eui_results.length,
    perPage: 100,
    context: 'Operation Device List',
    collectionId: payload.id,
    sort: ''
  })
}

export default {
  getDeviceStates,
  getPromiseDeviceStates,
  patchDeviceStateReset,
  patchDeviceWatchlistReset,
  getDeviceRevisions,
  getAppNetDeviceStates,
  getGatewayDeviceStates,
  getDeviceState,
  updateDeviceState,
  getDeviceProfileRevisions,
  getOperations,
  removeOperation,
  deleteOperation,
  addOperation,
  getOperationDevices
}



// WEBPACK FOOTER //
// ./src/modules/endDeviceStates/store/actions.js